import * as activityAnalyze from '../services/activityAnalyze';

export default {
  namespace: 'activityAnalyze',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
    activityVerificationList: [],
    total: 1,
  },

  effects: {
    //活动预约详情
    *getActivityBookingQuery({ payload: { values }, callback }, { call, put }) {
      const response = yield call(
        activityAnalyze.getActivityBookingQuery,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          activityBookingQuery: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //门店列表
    *getStoreList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(activityAnalyze.getStoreList, values);
      yield put({
        type: 'save',
        payload: {
          storeList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //明细列表查询
    *getQueryAnalysesDetailPage(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        activityAnalyze.getQueryAnalysesDetailPage,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          analysesDetailPage: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //核销明细列表查询
    *getQueryConsumeDetail({ payload: { values }, callback }, { call, put }) {
      const response = yield call(
        activityAnalyze.getQueryConsumeDetail,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          activityVerificationList: response?.data?.data,
          total: response?.data?.total,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
